// extracted by mini-css-extract-plugin
export var timetableWrapper = "timetable-module--timetableWrapper--mQS3J";
export var importantMessage = "timetable-module--importantMessage--9LzIr";
export var dropdownWrapper = "timetable-module--dropdownWrapper--9OnYV";
export var dropdown = "timetable-module--dropdown--PIISJ";